import { Container, Grid } from "@mantine/core";
import { useDocumentTitle } from "@mantine/hooks";
import {  useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import loginImage from "../../assets/images/emtech_connection_image.svg";
import {
	PrimaryButtonWithoutIcon,
	SecondaryButton,
} from "../../components/Buttons";
import { WalletTransferModal } from "../../components/modals/WalletTransferModal";
import { MEMBER_ROUTE, device } from "../../lib/constants";

const Screen = styled(Container)`
  min-height: 100vh;
  padding: 0;
  a {
    font-size: 13px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.primary.black};
  }
`;

const PageContainer = styled.div`
  min-height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.laptop} {
    margin-top: 0;
  }
`;

const InnerWrapper = styled(Grid)`
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media ${device.tablet} {
    padding: 16px;
    margin: 0;
    justify-content: flex-start;
  }
`;

const ImageWrapper = styled.div`
  @media ${device.tablet} {
  }
`;

const GetStartedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 400px;
  @media ${device.tablet} {
    max-width: none;
  }
`;

const LoginPageImage = styled.img`
  max-width: 350px;
  @media ${device.laptop} {
    max-width: 200px;
  }

  @media ${device.mobileL} {
    max-width: 130px;
  }
`;

const ButtonContainer = styled.div`
  margin: 12px auto 0 0;
  display: flex;
  align-items: center;
  @media ${device.mobileL} {
    width: 100%;
  }
`;

const TopRightButtonContainer = styled.div`
  top: 56px;
  right: 56px;
  position: absolute;
  display: flex;
  align-items: center;
  @media ${device.mobileL} {
    width: 100%;
  }
`;

const LandingPageButton = styled(PrimaryButtonWithoutIcon)`
  max-width: 144px;
  height: 40px;
  @media ${device.mobileL} {
    width: 100%;
  }
`;

const RequestsButton = styled(PrimaryButtonWithoutIcon)`
  max-width: 184px;
  height: 40px;
`;

const OtherButton = styled(SecondaryButton)`
  max-width: 144px;
  margin-left: 24px;
  height: 40px;
`;

const DashboardButton = styled(SecondaryButton)`
  max-width: 184px;
  margin-right: 24px;
  height: 40px;
  @media ${device.mobileL} {
    width: 100%;
  }
`;
export const DashboardLandingPage = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [showWalletTransferModal, setShowWalletTransferModal] =
		useState<boolean>(false);
	useDocumentTitle(`DAP: ${t("navigation.home")}`);

	return (
		<Screen fluid>
			<PageContainer>
				<TopRightButtonContainer>
					<DashboardButton
						title="View Dashboard"
						onClick={() => {
							navigate(MEMBER_ROUTE.DASHBOARD);
						}}
					/>
					<RequestsButton
						title="Manage Requests"
						onClick={() => {
							navigate(MEMBER_ROUTE.REQUESTS);
						}}
					/>
				</TopRightButtonContainer>
				<InnerWrapper>
					<ImageWrapper>
						<LoginPageImage src={loginImage} alt="Login" />
					</ImageWrapper>
					<GetStartedWrapper>
						<h1 className="text-2xl m-0 mb-4 text-center text-textColor">Navigate Platform</h1>
						<ButtonContainer>
							<LandingPageButton
								title="Transfer Funds"
								onClick={() => {
									setShowWalletTransferModal(true);
								}}
							/>
							<OtherButton
								title="Manage BYDC"
								onClick={() => {
									navigate(MEMBER_ROUTE.CURRENCY_MANAGEMENT);
								}}
							/>
						</ButtonContainer>
					</GetStartedWrapper>
				</InnerWrapper>
			</PageContainer>
			<WalletTransferModal
				isVisible={showWalletTransferModal}
				setIsVisible={setShowWalletTransferModal}
			/>
		</Screen>
	);
};
